
















































import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class StepHead extends Vue {
    @Prop(Boolean) showBtn: boolean;
    @Prop({ default: true }) showTooltip: boolean;
    @Prop({ default: "Страхователь" }) headtext: string;
    @Prop({ default: "" }) tooltipText: string;
}
